import type { ComponentType } from 'react';
import LandingPage from '../pages/LandingPage';
import RegisterSelect from '../pages/RegisterSelect';
import RegisterPrivate from '../pages/RegisterPrivate';
import RegisterOrg from '../pages/RegisterOrg';
import PortalLogin from '../pages/PortalLogin';
import Introduction from '../pages/Introduction';
import OrgAdmin from '../pages/OrgAdmin';
import ProSetup from '../pages/ProSetup';
import Workspace from '../pages/Workspace';
import { ROUTES } from './classroomRoutes';
import { SCREENS, SCREEN_ROUTES } from './screenRegistry';

export interface MaintenancePreviewScreen {
  screenId: string;
  label: string;
  route: string;
  Component: ComponentType;
}

/** Tab 7 — Mentology Classroom viewports MPL-01..MPL-10 (+ MPL-11). */
export const MAINTENANCE_PREVIEW_SCREENS: MaintenancePreviewScreen[] = [
  {
    screenId: SCREENS.MPL01,
    label: 'MPL-01 · Global Landing Page',
    route: SCREEN_ROUTES[SCREENS.MPL01],
    Component: LandingPage,
  },
  {
    screenId: SCREENS.MPL02,
    label: 'MPL-02 · Registration Pathway Selector',
    route: SCREEN_ROUTES[SCREENS.MPL02],
    Component: RegisterSelect,
  },
  {
    screenId: SCREENS.MPL03,
    label: 'MPL-03 · Private Registration',
    route: SCREEN_ROUTES[SCREENS.MPL03],
    Component: RegisterPrivate,
  },
  {
    screenId: SCREENS.MPL04,
    label: 'MPL-04 · Organisation Registration',
    route: SCREEN_ROUTES[SCREENS.MPL04],
    Component: RegisterOrg,
  },
  {
    screenId: SCREENS.MPL06,
    label: 'MPL-06 · Classroom Portal (Key Validation)',
    route: SCREEN_ROUTES[SCREENS.MPL06],
    Component: PortalLogin,
  },
  {
    screenId: SCREENS.MPL07,
    label: 'MPL-07 · Executive Introduction',
    route: SCREEN_ROUTES[SCREENS.MPL07],
    Component: Introduction,
  },
  {
    screenId: SCREENS.MPL08,
    label: 'MPL-08 · Organisation Admin Console',
    route: SCREEN_ROUTES[SCREENS.MPL08],
    Component: OrgAdmin,
  },
  {
    screenId: SCREENS.MPL09,
    label: 'MPL-09 · Individual Student Setup',
    route: SCREEN_ROUTES[SCREENS.MPL09],
    Component: ProSetup,
  },
  {
    screenId: SCREENS.MPL10,
    label: 'MPL-10 · Live Classroom Workspace',
    route: SCREEN_ROUTES[SCREENS.MPL10],
    Component: Workspace,
  },
];

function MasterAdminConsolePreview() {
  return (
    <div className="master-admin-preview-shell">
      <p className="master-admin-preview-shell-label">Screen-MPL-11 · Master Admin Console</p>
      <p className="master-admin-preview-shell-note">
        You are already inside Screen-MPL-11. Use the sidebar tabs to review Students, Key Generator,
        and other master console panels. Other viewports preview in the canvas when selected from the list.
      </p>
    </div>
  );
}

export const MAINTENANCE_PREVIEW_SCREENS_WITH_CONSOLE: MaintenancePreviewScreen[] = [
  ...MAINTENANCE_PREVIEW_SCREENS,
  {
    screenId: SCREENS.MPL11,
    label: 'MPL-11 · Master Admin Console (this session)',
    route: ROUTES.MASTER_ADMIN,
    Component: MasterAdminConsolePreview,
  },
];
